/* eslint-disable max-len */
export default {
    modal: {
        actEnd: {
            title: 'キャンペーン終了',
            desc: 'プロモーションセンターで最新のオファーをご覧ください',
            btn: '移動'
        },
        noCrowd: {
            title: 'このキャンペーンは<br/>新規ユーザーのみ対象です',
            desc: '他のキャンペーンを見る',
            btn: '移動'
        }
    },
    message: {
        sendSuccess: 'おめでとうございます！\n報酬を受け取りました'
    }
};
